export function SET_SESSION_LIST (state, sessionList) {
  state.sessionList = sessionList
}

export function ADD_OPENED_SESSION (state, sessionId) {
  if (!state.openedSessionIdList.includes(sessionId)) {
    state.openedSessionIdList.push(sessionId)
  }
}

export function ADD_OPENED_SESSION_LIST (state, sessionIdList) {
  state.openedSessionIdList.push(
    ...sessionIdList.filter(sessionId => !state.openedSessionIdList.includes(sessionId)),
  )
}

export function REMOVE_OPENED_SESSION (state, sessionId) {
  state.openedSessionIdList = state.openedSessionIdList
    .filter(id => id !== sessionId)
}

export function PATCH_SESSION (state, { id, ...updatedFields }) {
  state.sessionList = state.sessionList
    .map(session => (session.id === id ? { ...session, ...updatedFields } : session))
}

export function PATCH_GAME (state, { sessionId, id, ...updatedFields }) {
  const session = state.sessionList.find(item => item.id === sessionId)
  session.gameList = session.gameList
    .map(game => (game.id === id ? { ...game, ...updatedFields } : game))
}

export function SAVE_LAST_ROUTE_HISTORY (state, { sessionId, path }) {
  state.sessionLastRouteHistory[sessionId] = path
}

export function RESET_STATE (state) {
  Object.assign(state, {
    openedSessionIdList: [],
    sessionList: [],
    sessionLastRouteHistory: {},
  })
}
